import { render, staticRenderFns } from "./majorBindCampusDialog.vue?vue&type=template&id=173423c0&"
import script from "./majorBindCampusDialog.vue?vue&type=script&lang=js&"
export * from "./majorBindCampusDialog.vue?vue&type=script&lang=js&"
import style0 from "./majorBindCampusDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports